<template>
  <div class="services-sidebar-section" v-if="numbersSelected">
    <div class="services-sidebar-section__head">
      <label>
        <span>2</span>
        <input
            v-model="searchCountries"
            :placeholder="getLocalization('Find country')"
            @input="handleSearchInput"
        />
        <img src="/img/svg/common/search-black.svg"/>
      </label>
      <button class="button primary" @click="isOpenFilter = !isOpenFilter">
        {{ getLocalization('Sort by') }}
      </button>
    </div>

    <SortFilterPanel
        v-if="isOpenFilter"
        :activeFilter="activeFilter"
        :sortOptions="{
        price: sortByPriceOption,
        quantity: sortByQuantityOption,
        top: sortByTopOption
      }"
        @sort-by-price="handleSortByPrice"
        @sort-by-quantity="handleSortByQuantity"
        @sort-by-top="handleSortByTop"
    />

    <div
        v-if="filteredAndSortedCountries.length > 0 || isMounted"
        class="services-sidebar-section__body services-sidebar__countries --more"
    >
      <CountryItem
          v-for="(country, index) in filteredAndSortedCountries"
          :key="index"
          :country="country"
          :is-open="selectedCountryId === country.id"
          :individual-prices="individualPrices"
          :selected-service=selectedService
          @buy-number="$emit('buy-number', ...arguments)"
          @toggle-country="handleToggleCountry"
          @sort-position="handleSortPosition"
      />
    </div>

    <div v-else class="services-sidebar-section__body services-sidebar__countries --more">
      <SkeletonLoader v-for="(_, index) in rowsCountry" :key="index" type="country"/>
    </div>

    <div class="services-sidebar-section__footer footer-for-phone-numbers" @click="scrollDown">
      <span class="arrow-down"></span>
      {{ getLocalization('View more') }}
    </div>
  </div>
</template>

<script>
import SortFilterPanel from './sortFilterPanel.vue';
import CountryItem from './countryItem.vue';
import SkeletonLoader from './skeletonLoader.vue';
import MailDomainItem from "./mailDomainItem.vue";

export default {
  components: {
    MailDomainItem,
    SortFilterPanel,
    CountryItem,
    SkeletonLoader
  },
  props: {
    numbersSelected: Boolean,
    serviceCountries: Array,
    isMounted: Boolean,
    rowsCountry: [Array, Number],
    selectedCountryId: [Number, null],
    openCounties: Array,
    individualPrices: Object,
    selectedService: Object,
  },
  data() {
    return {
      searchCountries: '',
      isOpenFilter: false,
      activeFilter: 3, // По умолчанию сортировка по топу
      sortByPriceOption: 0, // 0 - top, 1 - bottom
      sortByQuantityOption: 0,
      sortByTopOption: 0,
      currentSort: {
        type: 'top',
        direction: 'top'
      }
    };
  },
  computed: {
    filteredCountries() {
      if (!this.serviceCountries) return [];

      const searchTerm = this.searchCountries.toLowerCase().trim();
      if (!searchTerm) return this.serviceCountries;

      return this.serviceCountries.filter(country => {
        const title = this.getLocalization(country.title).toLowerCase();
        const altTitle = country.alternative_title_locale?.toLowerCase() || '';
        return title.includes(searchTerm) || altTitle.includes(searchTerm);
      });
    },
    filteredAndSortedCountries() {
      return this.sortCountries([...this.filteredCountries]);
    }
  },
  methods: {
    getLocalization(key) {
      return this.$root.getLocalization
          ? this.$root.getLocalization(key)
          : key;
    },
    handleSearchInput() {
      // Сбрасываем выбранную страну при изменении поиска
      if (this.selectedCountryId) {
        this.$emit('toggle-country', null);
      }
    },
    sortCountries(countries) {
      return countries.sort((a, b) => {
        switch (this.currentSort.type) {
          case 'price':
            return this.currentSort.direction === 'top'
                ? a.min_price - b.min_price
                : b.min_price - a.min_price;
          case 'quantity':
            return this.currentSort.direction === 'top'
                ? a.count - b.count
                : b.count - a.count;
          case 'top':
          default:
            return this.currentSort.direction === 'top'
                ? (a.rate || 9999) - (b.rate || 9999)
                : (b.rate || 9999) - (a.rate || 9999);
        }
      });
    },
    scrollDown() {
      const target = document.querySelector('.services-sidebar-section__body.services-sidebar__countries.--more');
      if (target) {
        target.scrollBy({
          top: 50,
          left: 0,
          behavior: 'smooth'
        });
      }
    },
    handleSortByPrice() {
      this.activeFilter = 1;
      this.sortByPriceOption = this.sortByPriceOption === 0 ? 1 : 0;
      this.currentSort = {
        type: 'price',
        direction: this.sortByPriceOption === 0 ? 'top' : 'bottom'
      };
    },
    handleSortByQuantity() {
      this.activeFilter = 2;
      this.sortByQuantityOption = this.sortByQuantityOption === 0 ? 1 : 0;
      this.currentSort = {
        type: 'quantity',
        direction: this.sortByQuantityOption === 0 ? 'top' : 'bottom'
      };
    },
    handleSortByTop() {
      this.activeFilter = 3;
      this.sortByTopOption = this.sortByTopOption === 0 ? 1 : 0;
      this.currentSort = {
        type: 'top',
        direction: this.sortByTopOption === 0 ? 'top' : 'bottom'
      };
    },
    handleToggleCountry(id) {
      this.$emit('toggle-country', id);
    },
    handleSortPosition(country, type) {
      this.$emit('sort-position', country, type);
    }
  }
}
</script>